import { render, staticRenderFns } from "./AirLeeChooseResvItem.vue?vue&type=template&id=4210c1ee&"
import script from "./AirLeeChooseResvItem.vue?vue&type=script&lang=js&"
export * from "./AirLeeChooseResvItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports